import { ACHAccountType, BankAccountLocation, BankAccountScheme } from '@40seas/entities/bank-account';
import { Country } from '@40seas/entities/common';
import { Currency } from '@40seas/models';
import { bankAccountSchemeDictionary } from '@40seas/shared/bank-account';
import { z } from 'zod';

const SWIFT_WITH_IBAN_COUNTRIES: Country[] = [
    Country.UNITED_ARAB_EMIRATES,
    Country.UNITED_KINGDOM,
    Country.ROMANIA,
    Country.GIBRALTAR,
    Country.PAKISTAN,
];

export const withBankAccountFields = (schema: z.ZodObject<any>) => {
    return z
        .preprocess((val: any) => {
            const currency = val?.bankAccountDetails?.currency;
            const location = val?.bankAccountDetails?.location;
            const bankaccountScheme = bankAccountSchemeDictionary[`${currency}_${location || BankAccountLocation.Domestic}`];
            if (!val.bankAccountDetails.bankAccountPayload) {
                val.bankAccountDetails.bankAccountPayload = {};
            }
            val.bankAccountDetails.bankAccountPayload.type = bankaccountScheme as BankAccountScheme;
            if (
                val.bankAccountDetails.bankAccountPayload.type === BankAccountScheme.ACH ||
                val.bankAccountDetails.bankAccountPayload.type === BankAccountScheme.ACSS
            ) {
                val.bankAccountDetails.bankAccountPayload.accountType = ACHAccountType.Checking;
            }

            const country = val?.bankAccountDetails?.bankAddress?.country;
            const isSwiftWithIbanCountry = country && SWIFT_WITH_IBAN_COUNTRIES.includes(country);
            const isUsdCurrency = currency === Currency.USD || currency === 'USD';

            if (isSwiftWithIbanCountry && isUsdCurrency) {
                val.bankAccountDetails.bankAccountPayload.type = BankAccountScheme.SWIFTWithIban;
                val.bankAccountDetails.bankAccountPayload.iban = val.bankAccountDetails.bankAccountPayload.accountNumber;
                delete val.bankAccountDetails.bankAccountPayload.accountNumber;
            }
            return val;
        }, schema)
        .refine(
            (val) => {
                return !!val?.bankAccountDetails?.bankAddress;
            },
            {
                message: 'Required',
                path: ['bankAccountDetails.bankAddress.addressLine1'],
            },
        );
};
